/**
 * KAN-764: дни недели (ISO 1=пн..7=вс) для окна рассылки.
 *
 * Чистые функции: нормализация значения из values канала и короткая подпись
 * ("пн-пт", "пн, ср-пт, вс"). Компонент выбора - components/common/WeekdaysPicker.
 */

export const WEEKDAYS: ReadonlyArray<{ day: number; label: string; short: string }> = [
  { day: 1, label: 'Пн', short: 'пн' },
  { day: 2, label: 'Вт', short: 'вт' },
  { day: 3, label: 'Ср', short: 'ср' },
  { day: 4, label: 'Чт', short: 'чт' },
  { day: 5, label: 'Пт', short: 'пт' },
  { day: 6, label: 'Сб', short: 'сб' },
  { day: 7, label: 'Вс', short: 'вс' },
];

export const DEFAULT_WEEKDAYS: number[] = [1, 2, 3, 4, 5];

export const WEEKDAYS_REQUIRED_ERROR = 'Выберите хотя бы один день';

/** Отсортированный список уникальных дней 1..7 из массива или строки "1,2,3"; иное - null. */
export function normalizeWeekdays(raw: unknown): number[] | null {
  // Backend parse_workdays also accepts a comma string ("1,2,3,4,5").
  const items: unknown[] | null =
    typeof raw === 'string' ? raw.split(',').map((part) => part.trim()) : Array.isArray(raw) ? raw : null;
  if (items === null) return null;
  const days = new Set<number>();
  for (const item of items) {
    const num = typeof item === 'number' ? item : Number(item);
    if (Number.isInteger(num) && num >= 1 && num <= 7) days.add(num);
  }
  return Array.from(days).sort((a, b) => a - b);
}

function shortName(day: number): string {
  return WEEKDAYS[day - 1]?.short ?? String(day);
}

/** Подпись дней: подряд идущие (3 и больше) сворачиваются через дефис. */
export function formatWeekdays(days: number[]): string {
  const sorted = normalizeWeekdays(days) ?? [];
  const parts: string[] = [];
  let i = 0;
  while (i < sorted.length) {
    let j = i;
    while (j + 1 < sorted.length && sorted[j + 1] === sorted[j] + 1) j += 1;
    if (j - i >= 2) {
      parts.push(`${shortName(sorted[i])}-${shortName(sorted[j])}`);
    } else {
      for (let k = i; k <= j; k += 1) parts.push(shortName(sorted[k]));
    }
    i = j + 1;
  }
  return parts.join(', ');
}
